// Copyright ©️ 2026 eVolve MEP, LLC

import type { TableViewType } from '@evolvemep/api-ts';
import type { GridState } from 'ag-grid-enterprise';

/**
 * These are client-defined IDS for the different top-level tables in the app that support table views.
 *
 * NOTE: Changing one of these values will require a data migration to update existing table views.
 * */
export const TABLE_VIEW_TYPE = {
  BILL_OF_MATERIALS: 'bill-of-materials' as TableViewType,
  WORK_ORDER_BILL_OF_MATERIALS: 'wo-bill-of-materials' as TableViewType,
  WORK_ORDER_ITEM_BILL_OF_MATERIALS: 'wo-item-bill-of-materials' as TableViewType,
  CUSTOMERS: 'customers' as TableViewType,
  WORK_ORDER_FABRICATION_ITEMS: 'work-order-fabrication-items' as TableViewType,
  FABRICATION_ITEMS_MODAL: 'fabrication-items-modal' as TableViewType,
  FACILITIES: 'facilities' as TableViewType,
  LICENSES: 'licenses' as TableViewType,
  MEMBERS: 'members' as TableViewType,
  PARTS: 'parts' as TableViewType,
  PRODUCT_FEATURES: 'product-features' as TableViewType,
  PROJECTS: 'projects' as TableViewType,
  REVIT_DOWNLOADS: 'revit-downloads' as TableViewType,
  TASK_DATA_INSIGHTS: 'task-data-insights' as TableViewType,
  TASKS: 'tasks' as TableViewType,
  TIME_TRACKING: 'time-tracking' as TableViewType,
  SHIPPING_ORDERS: 'shipping-orders' as TableViewType,
  WORK_ORDERS: 'work-orders' as TableViewType,

  // Fallback for TableViewContext default value.
  UNKNOWN: 'unknown' as TableViewType,
} satisfies Record<string, TableViewType>;

export const SAVED_GRID_STATE_KEYS = [
  'columnOrder',
  'columnPinning',
  'columnSizing',
  'columnVisibility',
  'filter',
  'sort',
] as const satisfies (keyof GridState)[];
